module.exports = __webpack_public_path__ + "06eec2cf9810bb5ff5793ff313fefa83.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/cetabever/enlwdc.png
// module id = 2417
// module chunks = 0